<template>
    <v-layout align-center justify-end>
        <div>
            <v-chip
                data-testid="billing-status-chip"
                class="billing-status-chip primary white--text"
                :active="billingStatusChip"
                close
                @click:close="clearBillingStatus"
                key="billing-status"
            >
                <span data-testid="billing-status-text">{{ filter.billingStatus }}</span>
            </v-chip>
            <v-chip
                data-testid="name-phone-chip"
                class="name-phone-chip primary white--text"
                :active="nameOrPhoneChip"
                close
                @click:close="clearNameOrPhone"
                key="name-or-phone"
            >
                <span data-testid="name-phone-text">{{ filter.nameOrPhone }}</span>
            </v-chip>
        </div>
        <v-menu
            data-testid="calls-filter-menu"
            class="calls-filter-menu"
            v-model="menu"
            left
            offset-y
            :close-on-content-click="false"
            :min-width="600"
        >
        <template v-slot:activator="{ on, attrs }">
        <v-btn
          data-testid="filter-by-btn"
                    class="filter-by-btn ml-4"
                    text
                    depressed
                    v-on="on"
          v-bind="attrs"
        >
          Filter By
                    <v-icon class="ml-2">filter_list</v-icon>
        </v-btn>
      </template>
            <!-- <template v-slot:activator="{ on }">
                <v-btn
                    data-testid="filter-by-btn"
                    class="filter-by-btn ml-4"
                    text
                    depressed
                    v-on="on"
                >
                    Filter By
                    <v-icon class="ml-2">filter_list</v-icon>
                </v-btn>
            </template> -->
            <v-card data-testid="filter-menu">
                <v-list class="pa-0 ma-0">
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-bold">
                                Select from the dropdown to add filters
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider />
                <v-list class="pt-3 pb-2 px-4">
                    <v-select
                        data-testid="filter-by-billing-menu"
                        class="filter-by-billing-menu"
                        v-model="filter.billingStatus"
                        placeholder="- Select filter option -"
                        label="Filter by billing status"
                        :items="['Auto Pay Enabled (past due tenants)', 'Over 5 Days Past Due']"
                    />
                    <v-text-field
                        data-testid="filter-by-name-phone-input"
                        class="filter-by-name-phone-input mt-3"
                        v-model="filter.nameOrPhone"
                        placeholder="ex: John Doe"
                        label="Filter by name or phone"
                    />
                </v-list>
                <v-card-actions>
                    <v-btn
                        data-testid="apply-filter-btn"
                        class="apply-filter-btn"
                        color="primary"
                        id="apply-filter"
                        @click="filtersApplied"
                        :disabled="!filter.billingStatus && !filter.nameOrPhone"
                    >
                        Apply Filter
                    </v-btn>
                    <v-btn
                        data-testid="clear-filter-btn"
                        class="clear-filter-btn ml-3"
                        color="error"
                        id="clear-filter"
                        @click="clearFilters"
                    >
                        Clear All
                    </v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-menu>
    </v-layout>
</template>

<script>
export default {
  name: "CallsFilter",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      billingStatusChip: false,
      filter: {
        billingStatus: "",
        nameOrPhone: ""
      },
      menu: false,
      nameOrPhoneChip: false
    };
  },
  methods: {
    filtersApplied() {
      if (this.filter.billingStatus) {
        this.billingStatusChip = true;
      } else {
        this.billingStatusChip = false;
      }
      if (this.filter.nameOrPhone) {
        this.nameOrPhoneChip = true;
      } else {
        this.nameOrPhoneChip = false;
      }
      this.menu = false;
      this.$emit("filtersApplied", this.filter);
    },
    clearBillingStatus() {
      this.filter.billingStatus = "";
      this.$emit("clearBilling");
      this.filtersApplied();
    },
    clearNameOrPhone() {
      this.filter.nameOrPhone = "";
      this.$emit("clearNameOrPhone");
      this.filtersApplied();
    },
    clearFilters() {
      this.clearBillingStatus();
      this.clearNameOrPhone();
    }
  }
};
</script>
